<div class="modal">

    <header class="header">
        <span class="title">{{ model.label }}</span>
        <div class="close-button" (click)="close()">
            <i class="ju ju-close"></i>
        </div>
    </header>

    <div class="modal-content">

        <div class="image-container" [ngClass]="{'has-content': model.photo}">
            <img [id]="'image_' + model.label" [src]="'data:image/jpeg;base64,'+model.photo">
        </div>

        <div class="button-container">
            <div class="button delete-button" (click)="onRemoveBtnClicked()">
                <span>Löschen</span>
            </div>
            <div class="button refresh-button" *ngIf="model.photo" (click)="selectImage()">
                <span>Ändern</span>
                <input class="custom-file-input" type="file" [ngClass]="{'small':model.photo}"
                       [id]="'input_' + model.label" accept="image/jpg, image/jpeg, image/png"
                       (change)="processFile($event)">
            </div>
        </div>
    </div>
</div>
